var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';
export const TextInput = (_a) => {
    var { children, icon, autoFocus = false, accessInputRef, className, state = 'default', label, placeholder, onPressEnter, onEscape, onArrowUp, onArrowDown, disabled = false } = _a, props = __rest(_a, ["children", "icon", "autoFocus", "accessInputRef", "className", "state", "label", "placeholder", "onPressEnter", "onEscape", "onArrowUp", "onArrowDown", "disabled"]);
    const textRef = useRef(null);
    useEffect(() => {
        if (textRef.current) {
            if (autoFocus) {
                textRef.current.focus({ preventScroll: true });
            }
            if (accessInputRef) {
                accessInputRef(textRef.current);
            }
        }
    }, [autoFocus]);
    const handleKeyDown = event => {
        if (event.key === 'Enter' && onPressEnter) {
            onPressEnter(event);
        }
        else if (event.key === 'Escape' && onEscape) {
            onEscape(event);
        }
        else if (event.key === 'ArrowUp' && onArrowUp) {
            onArrowUp();
        }
        else if (event.key === 'ArrowDown' && onArrowDown) {
            onArrowDown();
        }
    };
    return (React.createElement("div", { className: classNames(className, 'text-input_container', {
            'text-input_icon': icon !== undefined,
            'text-input--error': state === 'error',
        }) },
        icon,
        React.createElement("input", Object.assign({ placeholder: placeholder, ref: textRef, className: "text-input_field", onKeyDown: handleKeyDown }, props, { disabled: disabled })),
        label && React.createElement("span", { className: "text-input_label" }, label),
        children));
};
//# sourceMappingURL=TextInput.js.map